<template>
  <div class="page-container">
    <div class="login-card">
      <header class="login-header">
        <h1>Admin Login</h1>
        <p>Masukkan kredensial Anda untuk mengakses panel.</p>
      </header>

      <main class="login-main">
        <form @submit.prevent="handleLogin">
          <div class="form-group">
            <label for="email">Email</label>
            <input id="email" v-model="email" type="email" placeholder="admin@example.com" required />
          </div>
          <div class="form-group">
            <label for="password">Password</label>
            <input id="password" v-model="password" type="password" placeholder="••••••••" required />
          </div>
          <button type="submit" class="button-primary" :disabled="isLoading">
            {{ isLoading ? 'Memproses...' : 'Login' }}
          </button>
        </form>
        <p v-if="error" class="error-message">{{ error }}</p>
      </main>
      
      <footer class="login-footer">
        <router-link :to="{ name: 'Home' }">Kembali ke Halaman Peserta</router-link>
      </footer>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import apiClient from '@/services/api.js';

const router = useRouter();
const email = ref('');
const password = ref('');
const error = ref('');
const isLoading = ref(false); // Tambahkan state loading

// src/views/admin/AdminLogin.vue

const handleLogin = async () => {
  isLoading.value = true;
  error.value = '';
  try {
    // 1. Buat objek URLSearchParams untuk Form Data
    const formData = new URLSearchParams();
    formData.append('username', email.value); // Backend mengharapkan 'username'
    formData.append('password', password.value);

    // 2. Kirim 'formData' dan set header Content-Type dengan benar
    // Kita TIDAK perlu menggunakan apiClient di sini karena interceptor-nya
    // dirancang untuk token, bukan login. Menggunakan axios langsung lebih bersih.
    // import axios from 'axios';
    const response = await apiClient.post('/admin/token', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    localStorage.setItem('admin_token', response.data.access_token);
    router.push({ name: 'AdminDashboard' });
  } catch (err) {
    error.value = 'Email atau password salah.';
    console.error("Login Error:", err.response); // Log respons error untuk debugging
  } finally {
    isLoading.value = false;
  }
};
</script>

<style scoped>
/* Gunakan style yang mirip dengan CodeEntry untuk konsistensi */
.page-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f0f2f5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.login-card {
  width: 100%;
  max-width: 400px;
  padding: 40px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}
.login-header h1 {
  margin: 0 0 10px 0;
  font-size: 24px;
  color: #333;
}
.login-header p {
  margin: 0;
  color: #666;
}

.form-group {
  margin-bottom: 20px;
}
.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #555;
}
.form-group input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-sizing: border-box;
  transition: border-color 0.2s;
}
.form-group input:focus {
  outline: none;
  border-color: #1abc9c;
  box-shadow: 0 0 0 2px rgba(26, 188, 156, 0.2);
}

.button-primary {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 6px;
  background-color: #34495e; /* Warna admin yang lebih gelap */
  color: white;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.button-primary:hover {
  background-color: #2c3e50;
}
.button-primary:disabled {
  background-color: #95a5a6;
  cursor: not-allowed;
}

.error-message {
  color: #e74c3c;
  margin-top: 15px;
  text-align: center;
}

.login-footer {
  text-align: center;
  margin-top: 30px;
  border-top: 1px solid #eee;
  padding-top: 20px;
}
.login-footer a {
  color: #777;
  text-decoration: none;
  font-size: 14px;
}
.login-footer a:hover {
  text-decoration: underline;
}
</style>